import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';

export const useInboxOnSectionCollapse = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (collapsedSections: ID[]) =>
      updateSettings({
        filters: {
          inbox: {
            collapsedSections,
          },
        },
      }),
    [updateSettings],
  );
};
